import React from "react"
import PropTypes from "prop-types"
import Section, { Container, Row, Col } from "@ui/wrapper"
import Button from "@ui/button"
import { demoExpert } from "../../../../dataMantiz/pages/company/aboutUs/demoExpert"

const CTASection = ({
  sectionStyle,
  heading,
  text,
  ButtonOne,
  ButtonTwo,
  ...props
}) => {


  return (
    <Section {...sectionStyle} >
      <Container>
        <Row style={{ textAlign: "center" }}>
          <Col>
            <img
              src={demoExpert.img}
              style={{ maxWidth: "60%", paddingTop: "20px", with: "20px" }}
            />
          </Col>

          <Col className="text-center" lg={{ spam: 20, offset: 20 }}>
            <h3
              style={{
                color: "#FFFFFF",
                paddingBottom: "1vw",
                paddingTop: "2vw",
              }}
            >
              {demoExpert.title1}
            </h3>
            <h5
              style={{
                color: "#FFFFFF",
                paddingBottom: "1vw",
                opacity: "0.75",
              }}
            >
              {demoExpert.title2}
              <br />
            </h5>

            <Button
              target="_blank"
              style={{
                color: "#FFFF",
                backgroundColor: "#448BC7",
                fontSize: "22px",
                fontWeight: "600",
                fontFamily: "Monserrat Bold",
                margin: "30px 0px",
              }}
              to={demoExpert.urlButton}
              {...ButtonOne}
              icondistance="8px"
              iconsize="16px"
            >
              {demoExpert.titleButton}
            </Button>
          </Col>
        </Row>
      </Container>
    </Section>
  )
}
CTASection.propTypes = {
  heading: PropTypes.object,
}
CTASection.defaultProps = {
  sectionStyle: {
    bgColor: "#315981",
    // bgposition: 'top 35% right -68px',
    bgsize: "auto",
    pt: "10px",
    pb: "10px",
    responsive: {
      medium: {
        pt: "60px",
        pb: "60px",
      },
      small: {
        pt: "40px",
        pb: "40px",
      },
    },
  },
  heading: {
    as: "h3",
    child: {
      color: "#FFFFFF",
    },
    responsive: {
      medium: {
        mb: "10px",
      },
    },
  },
  text: {
    color: "#FFFFFF",
  },

  ButtonOne: {
    background: "#086AD8",
    m: "7px",
  },
  ButtonTwo: {
    skin: "#FFFFFF",
    m: "7px",
  },
}
export default CTASection
